<section class="fulfillment-tabs">
  <button *ngFor="let tab of tabs; index as i" [class.inactive]="!tabs[i].isActive" (click)="onTabClick(i)">{{ tab.name }}</button>
</section>